import { zodResolver } from '@hookform/resolvers/zod';
import { Box, Button, FormHelperText, Stack, TextField } from '@mui/material';
import type { FC } from 'react';
import { Controller, useForm } from 'react-hook-form';
import type { ForgotPasswordFormType } from '~/types/ForgotPassword';
import { ForgotPasswordFormSchema } from '~/types/ForgotPassword';
import type { ForgotPasswordFormProps } from './ForgotPasswordForm.types';

export const ForgotPasswordForm: FC<ForgotPasswordFormProps> = ({ isPending, onSubmit }) => {
  const { handleSubmit, control } = useForm<ForgotPasswordFormType>({
    defaultValues: {
      email: '',
    },
    resolver: zodResolver(ForgotPasswordFormSchema),
  });

  return (
    <Box component="form" onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={4.75}>
        <Controller
          name="email"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <Box>
              <TextField {...field} error={!!error} label="Email Address" variant="outlined" size="medium" fullWidth />
              {error && error.message ? (
                <Box px={1.75} pt={0.375}>
                  <FormHelperText error>{error.message}</FormHelperText>
                </Box>
              ) : null}
            </Box>
          )}
        />

        <Button
          id="forgot_password_submit_button"
          size="large"
          color="primary"
          variant="contained"
          type="submit"
          fullWidth
        >
          {isPending ? 'Submitting...' : 'Submit'}
        </Button>
      </Stack>
    </Box>
  );
};
